__turbopack_context__.v({
  "header": "fOxa3G_header",
  "headerContent": "fOxa3G_headerContent",
  "paragraphTitle": "fOxa3G_paragraphTitle",
  "paragraphWrapper": "fOxa3G_paragraphWrapper",
  "wrapper": "fOxa3G_wrapper",
});
